import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import path from 'apex-web/lib/helpers/path';
import { getBEMClasses } from 'apex-web/lib/helpers/cssClassesHelper';

import './PopoverMenu.css';

import Popover from 'apex-web/lib/components/common/Popover/Popover';
import { MoonIcon } from './MoonIcon';
import { SunIcon } from './SunIcon';

export default class PopoverMenu extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          beforeLabelElement: PropTypes.element,
          onClick: PropTypes.func,
          linkTo: PropTypes.string,
          customClass: PropTypes.string
        }),
        PropTypes.shape({
          divider: PropTypes.oneOf([true]).isRequired
        })
      ])
    ).isRequired,
    customClass: PropTypes.string,
    popoverProps: PropTypes.shape({
      trigger: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    items: [],
    customClass: ''
  };

  constructor(props) {
    super(props);
    this.popoverRef = null;
    this.baseClasses = getBEMClasses(['popover-menu', this.props.customClass]);
  }

  getLinkElement = item => {
    return (
      <Link
        key={item.label}
        className={this.baseClasses('item', item.customClass)}
        to={path(item.linkTo)}
        onClick={() => this.popoverRef.toggleShow()}>
        {item.beforeLabelElement}
        <span className={this.baseClasses('item-label')}>{item.label}</span>
      </Link>
    );
  };

  getOnClickElement = item => {
    return (
      <a
        key={item.label}
        className={this.baseClasses('item', item.customClass)}
        onClick={this.getOnItemClick(item)}>
        {item.beforeLabelElement}
        <span className={this.baseClasses('item-label')}>{item.label}</span>
      </a>
    );
  };

  getOnItemClick = item => {
    return () => {
      if (typeof item.onClick !== 'undefined') {
        item.onClick();
        this.popoverRef.toggleShow();
      }
    };
  };

  getSwitchThemeElement = () => {
    const { updateTheme, currentTheme } = this.props;
    return (
      <div
        key="theme-switcher"
        className={this.baseClasses('theme-switcher-wrapper')}
        onClick={() => {
          updateTheme();
          this.popoverRef.toggleShow();
          document.location.reload(true);
        }}>
        <p>System Theme</p>
        <div className={this.baseClasses('theme-switcher')}>
          <div
            className={this.baseClasses(
              'theme-switcher-item',
              currentTheme === 'dark' ? 'active' : ''
            )}>
            <MoonIcon color={currentTheme === 'dark' ? '#fff' : '#D5D7DA'} />
          </div>
          <div
            className={this.baseClasses(
              'theme-switcher-item',
              currentTheme === 'light' ? 'active' : ''
            )}>
            <SunIcon color={currentTheme === 'light' ? '#fff' : '#535862'} />
          </div>
        </div>
      </div>
    );
  };

  renderContent = () => {
    const { items } = this.props;

    return items.map((item, index) => {
      if (item.divider) {
        return <div key={index} className={this.baseClasses('item-divider')} />;
      }

      if (item.linkTo) {
        return this.getLinkElement(item);
      }

      if (item.themeSwitcher) {
        return this.getSwitchThemeElement();
      }

      return this.getOnClickElement(item);
    });
  };

  render() {
    const { popoverProps } = this.props;

    return (
      <Popover
        ref={ref => (this.popoverRef = ref)}
        content={<div>{this.renderContent()}</div>}
        drawArrow
        isMenu="true"
        customClass={this.baseClasses()}
        {...popoverProps}
      />
    );
  }
}
